module.exports = __webpack_public_path__ + "static/media/Diverse3.9bc8e1d0.jpg";